import {UIGameTradeOffersScrollbox} from './UIGameTradeOffersScrollbox'
import {UIGameManager} from '../../ui_game/UIGameManager'
import {UIGameMechanic} from '../../ui_game/UIGameEventController'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import {Sound} from '../../Sound'
import {UIGameTradeOfferView} from './UIGameTradeOfferView'
import {ArrayUtils} from '@colonist/utils'
import {UIGamePlayerAvatarContainerView} from '../../ui_game/ui_game_popup/UIGamePlayerAvatarContainerView'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {UIGamePlayerAvatarStatus} from '../../ui_game/ui_game_players/UIGamePlayerAvatarView'
import {SpriteButtonView} from '../../ui_canvas_engine/SpriteButtonView'
import {UIGameTradeOfferViewHalf} from './UIGameTradeOfferViewHalf'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {Sprites} from '../../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIGameFlickerAnimation} from '../../ui_canvas_engine/animation/UIGameFlickerAnimation'
import {TradeEmbargoControllerReader} from '@colonist/game-base-types'
import {PlayerColor, TradeId, TradeOfferState, TradeResponseStatus} from '@colonist/game-states'
import {TradeActions, TradeErrorPayload, TradeValidator} from '@colonist/game-mechanic-validators'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export class UIGameTradeOffersController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager

    private playerEmbargoController: UIGamePlayerAvatarContainerView
    private offersScrollbox: UIGameTradeOffersScrollbox
    private eyeIcon: SpriteView | undefined
    private isGameInBackground: boolean = false
    protected offerViews: UIGameTradeOfferView[] = []

    private readonly tradeStates: {[key in TradeId]?: TradeOfferState}
    private counterOffersEnabled: boolean

    constructor(uiGameManager: UIGameManager, tradeStates: {[key in TradeId]?: TradeOfferState}) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.counterOffersEnabled = true

        this.tradeStates = tradeStates
        for(const tradeState of Object.values(this.tradeStates)) {
            if(tradeState == undefined) continue

            this.onCreateOffer(tradeState.id)
        }
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.RemoveTradeOffer: this.onRemoveOffer(data); break
            case UIGameEventEnums.TradeResponseState: this.onPlayerResponseStatus(data); break
            case UIGameEventEnums.NewTradeOfferReceived: this.onCreateOffer(data); break
            case UIGameEventEnums.CanvasResized: this.onCanvasResize(); break
            case UIGameEventEnums.PlayerControllerStateUpdated: this.onPlayerControllerState(); break
            case UIGameEventEnums.GameVisibilityUpdated: this.onGameVisibilityUpdated(data); break
            case UIGameEventEnums.EmbargoStatusUpdated:
                this.onPlayerEmbargoState()
                this.updateEmbargoStatuses()
                break
            case UIGameEventEnums.TemporaryPlayerStuckInEmbargoState: this.createTradeView(true); break
            case UIGameEventEnums.HighlightTradeOffer: this.highlightTradeOffer(data); break
            case UIGameEventEnums.TradePlayersCreatingCounterOfferState: this.onPlayerCreatingCounterOffer(data); break
            case UIGameEventEnums.BeginnerModeStart: this.counterOffersEnabled = false; break
            default: break
        }
    }

    get offerHeight(): number {
        if(UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return this.uiGameManager.canvasController.itemSize * 1.8
        return this.uiGameManager.canvasController.itemSize * 1.2
    }

    private createTradeView(temporaryPlayerStuckInEmbargo?: boolean) {
        this.destroyTradeView()
        this.createPlayerEmbargoController(temporaryPlayerStuckInEmbargo)
        this.createScrollBox()
    }

    private destroyTradeView() {
        if(this.playerEmbargoController != undefined) this.playerEmbargoController.destroy()
        if(this.offersScrollbox != undefined) this.offersScrollbox.destroyAndClear()
    }

    private createPlayerEmbargoController(temporaryPlayerStuckInEmbargo?: boolean) {
        const playerAvatarClickAction = (playerColor: PlayerColor) => {
            if(this.uiGameManager.gameController.isPlayerSpectator) return
            this.uiGameManager.socketGameSend.toggleEmbargoAgainstPlayer(playerColor)
        }

        const isMyTurn = this.uiGameManager.gameController.isMyTurn
        const players = isMyTurn ? this.uiGameManager.gameState.getOtherActivePlayerColors(this.uiGameManager.gameController.myColor) : [this.uiGameManager.gameController.currentState.currentTurnPlayerColor]
        const canvas = this.uiGameManager.canvasController
        const sectionHeight = this.offerHeight / 2
        const removePadding = true
        const avatarSize = sectionHeight * 0.695
        const avatarPadding = (sectionHeight - avatarSize) / 2

        const isUserOnMobileApp = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI

        const playerEmbargoControllerY = this.uiGameManager.gameLayout.getEmbargoControllerY()
        const playerAvatarContainerViewOptions = {
            playerAvatarClickAction: playerAvatarClickAction,
            showPlayerNames: false,
            topPadding: avatarPadding,
            removePadding: removePadding,
        }
        this.playerEmbargoController = new UIGamePlayerAvatarContainerView(this.uiGameManager, this.getTradeViewX(), playerEmbargoControllerY, this.getContentWidth(), sectionHeight, players, canvas.app.stage, playerAvatarContainerViewOptions)

        this.playerEmbargoController.resetAllPlayerAlpha()
        const spacingBetweenAvatars = avatarSize * 0.2
        this.playerEmbargoController.applySpacingBetweenPlayerAvatarsAndCenterInContainer(spacingBetweenAvatars)
        if(isUserOnMobileApp && !temporaryPlayerStuckInEmbargo) this.showHideAndViewTradesIcons()
        if(temporaryPlayerStuckInEmbargo) {
            const buttonSize = sectionHeight * 0.65
            const cancelButton = new SpriteButtonView(0, 0, buttonSize, buttonSize, this.playerEmbargoController)
            cancelButton.addCenteredIcon(UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_x))
            cancelButton.x = this.playerEmbargoController.width - cancelButton.width - this.uiGameManager.canvasController.margin
            cancelButton.y = this.playerEmbargoController.height - cancelButton.height - this.uiGameManager.canvasController.margin
            cancelButton.updateAction(() => {
                this.destroyPlayerEmbargoController()
            })
        }

        this.updateEmbargoStatuses()
    }

    private createScrollBox() {
        if(this.offersScrollbox != undefined) this.offersScrollbox.destroyAndClear()
        const app = this.uiGameManager.canvasController.app

        const margin = this.uiGameManager.canvasController.margin
        const scrollBoxY = this.playerEmbargoController.y + this.playerEmbargoController.height + margin
        this.offersScrollbox = new UIGameTradeOffersScrollbox(app.stage, this.getTradeViewX(), scrollBoxY, this.getTradeScrollBoxWidth())
    }

    private destroyPlayerEmbargoController() {
        if(this.playerEmbargoController == undefined) return
        this.playerEmbargoController.destroy()
    }

    private updateEmbargoStatuses() {
        const playOrder = this.uiGameManager.gameController.playOrder
        const myColor = this.uiGameManager.gameController.myColor
        for(const player of playOrder) {
            if(player == myColor) continue
            const embargoResult = TradeEmbargoControllerReader.doesPlayer1HaveAnEmbargoAgainstPlayer2(this.uiGameManager.gameController.tradeState.embargoState, myColor, player)
            this.updateEmbargoForPlayer(player, embargoResult)
        }
    }

    private updateEmbargoForPlayer(player: PlayerColor, embargo: boolean) {
        if(this.playerEmbargoController == undefined) return

        this.playerEmbargoController.setPlayerStatus(player, embargo ? UIGamePlayerAvatarStatus.Embargoed : UIGamePlayerAvatarStatus.None)
    }

    onCanvasResize() {
        if(this.offerViews.length == 0) return
        this.createTradeView()

        this.offerViews.forEach((offerView: UIGameTradeOfferView) => offerView.destroy({children: true}))
        this.offerViews = this.offerViews.map((view: UIGameTradeOfferView) => new UIGameTradeOfferView(this.uiGameManager, view.stateController, this.getContentWidth(), this.offerHeight, this.offersScrollbox.content))

        this.arrangeOffers()
    }

    onCreateOffer(tradeId: TradeId) {
        if(this.offerViews.length == 0) this.createTradeView()

        const tradeState = this.tradeStates[tradeId]
        if(tradeState == undefined) return

        this.createOffer(tradeState)
        this.arrangeOffers()
    }

    private createOffer(tradeState: TradeOfferState) {
        const currentTurnPlayer = this.uiGameManager.gameController.currentState.currentTurnPlayerColor
        const playerStates = this.uiGameManager.gameController.getPlayerValidators()
        const embargoState = this.uiGameManager.gameController.tradeState.embargoState
        const tradeStateController = new TradeValidator(tradeState, currentTurnPlayer, playerStates, embargoState)
        if(!this.counterOffersEnabled) tradeStateController.disableCounterOffers()
        const newOfferView = new UIGameTradeOfferView(this.uiGameManager, tradeStateController, this.getContentWidth(), this.offerHeight, this.offersScrollbox.content)
        this.offerViews.push(newOfferView)
        newOfferView.fadeIn()

        if(this.isGameInBackground) newOfferView.rejectTrade()

        const canIAcceptTrade = tradeStateController.getAcceptTradeActionStatus(this.uiGameManager.gameController.myColor).canTakeAction
        const soundToPlay = canIAcceptTrade ? Sound.SoundType.OfferAcceptable : Sound.SoundType.OfferNotAcceptable
        Sound.playSound(soundToPlay)
    }

    private onPlayerResponseStatus(tradeId: TradeId) {
        const offerView = this.getOffer(tradeId)
        if(offerView == undefined) return
        if(offerView.destroyed) return

        offerView.onPlayerResponseStatuses()
    }

    private onPlayerCreatingCounterOffer(tradeId: TradeId) {
        const offerView = this.getOffer(tradeId)
        if(offerView == undefined) return
        if(offerView.destroyed) return

        offerView.onPlayerCreatingCounterOffer()
    }

    private onPlayerEmbargoState() {
        for(const offerView of this.offerViews) {
            if(offerView == undefined) return
            if(offerView.destroyed) return

            offerView.onPlayerResponseStatuses()
            offerView.onPlayerActionState()
        }
    }

    private getOffer(offerId: string): UIGameTradeOfferView | undefined {
        return this.offerViews.find((offerView) => offerView.stateController.state.id == offerId)
    }

    protected onRemoveOffer(tradeId: TradeId) {
        const offerView = this.getOffer(tradeId)
        if(offerView == undefined) return

        const isLastOffer = this.getNonFadingOutOfferViews().length == 1
        if(isLastOffer) return this.removeOffer(offerView)

        offerView.fadeOut(() => this.removeOffer(offerView))
        this.arrangeOffers()
    }

    private removeOffer(offerView: UIGameTradeOfferView) {
        offerView.destroy({children: true})
        ArrayUtils.removeElementFromArray(this.offerViews, offerView)

        const isNotLastOffer = this.getNonFadingOutOfferViews().length > 0
        if(isNotLastOffer) return
        this.destroyTradeView()
        this.destroyPlayerEmbargoController()
        this.uiGameManager.toolTipController.closeTip()
    }

    private getNonFadingOutOfferViews(): UIGameTradeOfferView[] {
        return this.offerViews.filter((offerView: UIGameTradeOfferView) => offerView.isFadingOut == false)
    }

    private arrangeOffers() {
        if(this.offersScrollbox.destroyed) return

        const totalOfferViewsHeight = this.setOfferViewPositions()
        this.updateScrollboxHeight(totalOfferViewsHeight)

        if(this.offersScrollbox.visible == false) this.toggleOfferView()
    }

    private updateScrollboxHeight(newHeight: number) {
        const shouldMakeRoomForMovingOffer = newHeight > this.offersScrollbox.content.height
        if(shouldMakeRoomForMovingOffer) return this.offersScrollbox.updateHeight(newHeight)

        this.offersScrollbox.updateHeight()
    }

    // if not used by 18/02/2025, remove
    private sortCounterOffersBelowOriginalOffer() {
        const newOrder = [...this.offerViews]
        for(const offerView of this.offerViews) {
            if(offerView.destroyed) continue

            const isNotCounterOffer = offerView.stateController.state.counterOfferInResponseToTradeId == undefined
            if(isNotCounterOffer) continue

            const counteredTradeOfferIndex = this.offerViews.findIndex((view: UIGameTradeOfferView) => view.stateController.state.id == offerView.stateController.state.counterOfferInResponseToTradeId)
            if(counteredTradeOfferIndex == -1) continue
            if(this.offerViews[counteredTradeOfferIndex].destroyed) continue

            ArrayUtils.removeElementFromArray(newOrder, offerView)

            const indexToInsertOffer = counteredTradeOfferIndex + 1
            newOrder.splice(indexToInsertOffer, 0, offerView)
        }
        this.offerViews = newOrder
    }

    private setOfferViewPositions(): number {
        let offerY = 0
        let processedOffers = 0
        for(const offerView of this.offerViews) {
            processedOffers += 1
            if(offerView.destroyed) continue
            if(offerView.isFadingOut) continue

            const shouldMoveOffer = offerView.y != offerY
            const isLastOffer = processedOffers == this.offerViews.length

            if(shouldMoveOffer) this.moveOfferViewVertically(offerView, offerY, isLastOffer)
            offerView.isFirstMovement = false

            offerY += offerView.height + this.uiGameManager.canvasController.margin
        }
        return offerY
    }

    private moveOfferViewVertically(offerView: UIGameTradeOfferView, newY: number, isLastOffer: boolean) {
        if(offerView.isFirstMovement) return offerView.y = newY
        if(isLastOffer) {
            offerView.moveVertically(newY, () => {
                if(!this.offersScrollbox.destroyed) this.offersScrollbox.updateHeight()
            })
            return
        }
        return offerView.moveVertically(newY)
    }

    private onPlayerControllerState() {
        void this.playerEmbargoController?.refreshPlayerIcons()
        for(const offerView of this.offerViews) {
            if(offerView.destroyed) continue
            offerView.onPlayerControllerState()
        }
    }

    private getTradeScrollBoxWidth(): number {
        const isUserOnMobileApp = UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const isUserOnTabletApp = UIUtilsEjsVariables.isUserOnTabletApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI
        const mobileAppWidth = isUserOnTabletApp ? this.uiGameManager.canvasController.appW / 2 : this.uiGameManager.canvasController.appW
        if(isUserOnMobileApp) return mobileAppWidth

        const buttonSize = this.offerHeight / 2 * 0.9 - this.uiGameManager.canvasController.margin
        const actionButtonSectionWidth = UIGameTradeOfferViewHalf.getWidthOfButtonSection(this.uiGameManager, buttonSize)
        const tradeInformationViewWidth = this.uiGameManager.canvasController.itemSize * 2.25
        const scrollBoxWidth = actionButtonSectionWidth + tradeInformationViewWidth

        return scrollBoxWidth
    }

    private getTradeViewX(): number {
        if(UIUtilsEjsVariables.isUserOnTabletApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return 0
        const canvas = this.uiGameManager.canvasController
        return canvas.appW - canvas.chatWidth - this.getTradeScrollBoxWidth()
    }

    private getContentWidth(): number {
        const scrollBarMargin = UIUtilsEjsVariables.isUserOnMobileApp ? 0 : this.uiGameManager.canvasController.margin * 5
        return this.getTradeScrollBoxWidth() - scrollBarMargin
    }

    private showHideAndViewTradesIcons() {
        const eyeTexture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_eye_show)
        const iconsSize = this.uiGameManager.canvasController.itemSize * 0.5
        this.eyeIcon = new SpriteView(this.playerEmbargoController.width * 0.9, this.playerEmbargoController.height * 0.25, iconsSize, iconsSize, this.playerEmbargoController, eyeTexture)
        this.eyeIcon.setClickAction(() => this.toggleOfferView())
    }

    private toggleOfferView() {
        if(this.eyeIcon == undefined) return
        this.offersScrollbox.visible = !this.offersScrollbox.visible
        this.uiGameManager.eventController.sendEvent(this.offersScrollbox.visible, UIGameEventEnums.TradeOfferVisibilityUpdated)
        this.eyeIcon.texture = this.offersScrollbox.visible ? UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_eye_show) : UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_eye_hide)
    }

    private highlightTradeOffer(tradeError: TradeErrorPayload) {
        if(tradeError.highlightTrade == undefined) return

        for(const tradeId of tradeError.highlightTrade.tradeIds) {
            const offerView = this.getOffer(tradeId)
            if(offerView == undefined) continue
            if(offerView.destroyed) continue
            new UIGameFlickerAnimation(offerView).start()

            const myResponse = offerView.stateController.getPlayerResponseState(this.uiGameManager.gameController.myColor)
            if(myResponse == undefined) continue
            if(myResponse.responseStatus == TradeResponseStatus.Accepted) continue
            this.uiGameManager.socketGameSend.updateTradeResponse({id: tradeId, response: TradeActions.Accept})
        }
    }

    private onGameVisibilityUpdated(isGameVisible: boolean) {
        this.isGameInBackground = isGameVisible == false
        if(this.isGameInBackground == false) return

        this.offerViews.forEach((offerView: UIGameTradeOfferView) => {
            const isMyResponsePending = offerView.stateController.state.playerResponses[this.uiGameManager.gameController.myColor] == TradeResponseStatus.PendingResponse
            const amICreator = offerView.stateController.state.creator == this.uiGameManager.gameController.myColor
            if(!isMyResponsePending || amICreator) return
            offerView.rejectTrade()
        })
    }
}
